/**
 * Composes a unique form key for the memberships configuration form.
 * The key changes when the active config or its state (new/existing) changes,
 * which triggers form re-initialization.
 */
export const composeMembershipsFormKey = (
  activeConfigKey: string | null,
  isNewConfig: boolean,
): string => {
  if (!activeConfigKey) {
    return 'memberships-config-form:unselected';
  }

  return `memberships-config-form:${activeConfigKey}:${isNewConfig ? 'new' : 'existing'}`;
};
